module.exports = __webpack_public_path__ + "img/qiu360gaowei.40988661.png";